import {AdminStore} from "../config/store";
import {useStore} from "../hooks/useStore";
import { createActionCreator } from "@holta/lib";
import { localStorageMiddleware } from "../fns/localStorage";


export const createAction = createActionCreator<AdminStore>(useStore, [localStorageMiddleware]);